import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CasesService } from '../../services/cases.service';

@Component({
  selector: 'app-rdv-reposition',
  templateUrl: './rdv-reposition.component.html',
  styleUrls: ['./rdv-reposition.component.scss']
})
export class RdvRepositionComponent implements OnInit {
  @ViewChild('picker') datePicker!: MatDatepicker<any>;

  rdvForm: FormGroup;
  showDatePicker = false;
  showValidateButton = false;
  caseId: string;

   constructor(
    private fb: FormBuilder,
    private casesService: CasesService,
    public dialogRef: MatDialogRef<RdvRepositionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { caseId: string }
  ) {
    this.rdvForm = this.fb.group({
      rdv_repositionne: [null],
    });
     this.caseId = data.caseId;
  }
  ngOnInit(): void {

  }

  onNoClick(): void {
    this.casesService.updateRdv(this.caseId, null)
      .then(() => {
        this.dialogRef.close(false);
      })
      .catch(error => {
        console.error("Erreur lors de la mise à jour du RDV à null :", error);
      });
  }

  onYesClick(): void {
    this.showDatePicker = true;
    setTimeout(() => this.datePicker.open(), 0);
  }

  onDateSelected(event: any): void {
    this.showValidateButton = true;
    this.rdvForm.patchValue({ rdv_repositionne: event.value });

  }

  saveNewRdv(): void {

    if (this.rdvForm.value.rdv_repositionne) {

      this.casesService.updateRdv(this.caseId, this.rdvForm.value.rdv_repositionne)
        .then(() => {
          this.dialogRef.close(this.rdvForm.value.rdv_repositionne);
        })
        .catch(error => {
          console.error("Erreur lors de la mise à jour du RDV :", error);
        });
    }
  }

}
